<template>
  <div>

    <page-heading-info
    title="Jefferson County Clerk of Courts"
    phone="(740) 283-8583"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    floor="2nd Floor, Room 200"
    ></page-heading-info>

    <text-box-title title="Department Services">
      
      <div class="col-md-4 mt-3">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">Divorces</li>
          <li class="list-group-item">Civil Complaints</li>
          <li class="list-group-item">Criminal Felonies Only</li>
          <li class="list-group-item">Civil Stalking</li>
        </ul>
      </div>

      <div class="col-md-4 mt-3">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">Dissolutions</li>
          <li class="list-group-item">Judgement Liens</li>
          <li class="list-group-item">Court of Appeals</li>
        </ul>
      </div>

      <div class="col-md-4 mt-3">
        <ul class="list-group list-group-flush">
          <li class="list-group-item">Legal Seperation</li>
          <li class="list-group-item">Ohio Dept. of Taxation Liens</li>
          <li class="list-group-item">Domestic Violence</li>
        </ul>
      </div>

    </text-box-title>

    <div class="row bg-grey-01 mt-5 info-box align-items-center">
      <div class="col-md-6 p-3 text-center font-size-125">
        For questions and/or comments, please contact Alicia Anderson, Chief Deputy Clerk at&nbsp;<span class="text-bold">(740) 283-8583</span>
      </div>
    </div>

    <text-box-title title="Document Downloads">
      <note-documents note-id="19" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>

    <text-box-title title="Contacts" class="mt-3 justify-content-center">

      <div class="picture-box col-md-4 mt-3">
        <photo-info-card
        name="Angela Berdine"
        title="Title Office"
        phone="(740) 283-8509"
        ></photo-info-card>
      </div>

      <div class="picture-box col-md-4 mt-3">
        <photo-info-card
        name="Andrew D. Plesich"
        title="Clerk of Courts"
        phone="(740) 283-8509"
        ></photo-info-card>
      </div>

      <div class="picture-box col-md-4 mt-3">
        <photo-info-card
        name="Alicia Anderson"
        title="Legal Office"
        phone="(740) 283-8583"
        ></photo-info-card>
      </div>

    </text-box-title>

    <hr />

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import PhotoInfoCard from '@/components/display-utils/PhotoInfoCard.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import TextBox from '@/components/layout/TextBox.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'

export default {
  components: {
    PageHeadingInfo,
    PhotoInfoCard,
    TextBoxTitle,
    TextBox,
    NoteDocuments
  },
  data () {
    return {}
  },
  created: function() {
  }
}
</script>

<style scoped>
  .info-box {
    min-height: 200px;
  }

  .rules-box a {
    font-weight: bold;
  }

  .rules-box a:hover {
    opacity: 80%;
  }
</style>
